// src/components/PackingLists/LocationModal.js
import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import Modal from '../Modal';

/**
 * LocationModal component provides UI for managing storage locations
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Array} props.storageLocations - Available storage locations
 * @param {Function} props.addStorageLocation - Function to add a new storage location
 * @param {Function} props.deleteStorageLocation - Function to delete a storage location
 * @param {string} props.locationInput - Current location input value
 * @param {Function} props.setLocationInput - Function to update location input value
 * @returns {JSX.Element} Rendered component
 */
const LocationModal = ({ 
  isOpen, 
  onClose, 
  storageLocations, 
  addStorageLocation, 
  deleteStorageLocation,
  locationInput, 
  setLocationInput
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Manage Storage Locations"
    >
      <div className="location-modal-content">
      <Form className="add-location-form" onSubmit={addStorageLocation}>
        <InputGroup className="location-input-group">
          <Form.Control
            type="text"
            placeholder="New Location"
            value={locationInput}
            onChange={(e) => setLocationInput(e.target.value)}
            autoFocus
            required
          />
          <Button type="submit" variant="primary">Add</Button>
        </InputGroup>
      </Form>
        
        <div className="storage-locations-list">
          <h4>Current Locations:</h4>
          {storageLocations.length === 0 ? (
            <p>No storage locations added yet.</p>
          ) : (
            <ul>
              {storageLocations.map(location => (
                <li key={location.id} className="location-item">
                  <span>{location.name}</span>
                  <Button 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => deleteStorageLocation(location.id)}
                  >
                    Delete
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="modal-actions">
          <Button variant="success" onClick={onClose}>
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LocationModal;